module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone_lot.field.lot_name":"ชื่อ Lot","drone_lot.field.manufacture_date":"วันผลิต","drone_lot.field.remark":"หมายเหตุ","drone_lot.field.num_drones":"จำนวน Drone","lot_part.field.total":"จำนวน","lot_part.field.remark":"หมายเหตุ"}}')
  delete Component.options._Ctor
}
